import axios from 'axios';
import { API_SWEEPS_BASE_URL, API_ITV7_BASE_URL, API_TIMEOUT } from '../config';

export const apiClientInstance = axios.create({
    baseURL: API_SWEEPS_BASE_URL,
    timeout: API_TIMEOUT
});

export const itv7ApiClientInstance = axios.create({
    baseURL: API_ITV7_BASE_URL,
    timeout: API_TIMEOUT
});
